import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { analyticsService } from '../api/analytics.service';
import { ANALYTICS_KEYS } from './queryKeys';

export function useProjectHealth() {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: ANALYTICS_KEYS.projectHealth(activeOrganizationId ?? ''),
    queryFn: ({ signal }) => analyticsService.getProjectHealth(signal),
    staleTime: 120_000,
    enabled: !!activeOrganizationId,
  });
}
